import { memo, useMemo } from 'react'

import { Box, styled, Typography } from '@mui/material'
import { AvcInstance, AvcInstanceHealthEnum } from '@nativewaves/nw-cloud-sdk/content'
import { useTranslation } from 'react-i18next'

import { getHealthColor, getIsActiveColor } from 'utils'

const SecondaryTitleBadge = styled(Typography)<{ health: AvcInstanceHealthEnum }>(({ theme, health }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  height: 32,
  width: 100,
  borderRadius: 4,
  backgroundColor:
    health === 'OFFLINE' ? getIsActiveColor(false, theme.palette.mode) : getHealthColor(health, theme.palette.mode),
  color: theme.palette.getContrastText(
    health === 'OFFLINE' ? getIsActiveColor(false, theme.palette.mode) : getHealthColor(health, theme.palette.mode),
  ),
}))

type DynamicBadgeProps = Pick<AvcInstance, 'health'>

const DynamicBadgeRaw = ({ health = 'OFFLINE' }: DynamicBadgeProps) => {
  const { t } = useTranslation(['domain'])

  const healthDescription = useMemo(
    () => ({
      [AvcInstanceHealthEnum.Ok]: t('ContentProcessing.Instance.healthDescriptionOk'),
      [AvcInstanceHealthEnum.Warning]: t('ContentProcessing.Instance.healthDescriptionWarning'),
      [AvcInstanceHealthEnum.Critical]: t('ContentProcessing.Instance.healthDescriptionCritical'),
      [AvcInstanceHealthEnum.Offline]: t('ContentProcessing.Instance.healthDescriptionOffline'),
    }),
    [t],
  )

  return (
    <Box sx={{ display: 'flex', columnGap: 1, mx: 2 }}>
      <SecondaryTitleBadge variant="heading-sm" health={health}>
        {healthDescription[health]}
      </SecondaryTitleBadge>
    </Box>
  )
}

export const DynamicBadge = memo(DynamicBadgeRaw)
